import React from "react";
import { Progress, Card, Row, Col, Typography, Space, Flex } from "antd";
const { Title, Text } = Typography;

interface LeaveBalanceProps {
    data: Array<{
        type: string;
        percentage: number;
    }>;
}

const LeaveBalance: React.FC<LeaveBalanceProps> = ({ data }) => {
    return (
        <Card bordered={false}>
            <Title level={5}>Leave Balance</Title>
            <Row gutter={16} justify="center">
                {data.map((item, index) => (
                    <Col key={index} span={12} style={{ textAlign: "center" }}>
                        <Space direction="vertical">
                            <Progress type="circle" percent={item.percentage} size={60} />
                            <Text>{item.type}</Text>
                        </Space>
                    </Col>
                ))}
            </Row>
            <div style={{ textAlign: "right", marginTop: "10px" }}>
                <a href="/view-all">View all</a>
            </div>
        </Card>
    );
};

export default LeaveBalance;
